import React, { useState } from 'react';
import { BottomNavigation, BottomNavigationAction, Box, Fab, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SendIcon from '@mui/icons-material/Send';
import TimerIcon from '@mui/icons-material/Timer';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import DailyCheckInNew from '../DailyCheckIn/DailyCheckInNew';
import Photos from '../Photos/Photos';
import Vision from '../Vision/Vision';
import RequestForm from '../RequestForm/RequestForm';
import TaskSelection from '../TaskSelection/TaskSelection';
import AddTask from '../AddTask/AddTask';
import CountdownTimer from '../CountdownTimer/CountdownTimer';
import CalorieAI from '../CalorieAI/CalorieAI';

function TabPanel({ children, value, index, ...other }) {
  const [hasRendered, setHasRendered] = useState(value === index);
  
  if (value === index && !hasRendered) {
    setHasRendered(true);
  }

  return (
    <div
      role="tabpanel"
      style={{
        width: '100%',
        display: value === index ? 'block' : 'none',
        padding: '20px 0',
      }}
      {...other}
    >
      {hasRendered ? children : null}
    </div>
  );
}

function TabView() {
  const [value, setValue] = useState(0);
  const [showAddTask, setShowAddTask] = useState(false);
  const [showRequestForm, setShowRequestForm] = useState(false);

  
  // Navigation configuration (Timer removed from nav bar, moved to pig emoji menu)
  const navConfig = [
    { label: 'Vision', icon: <VisibilityIcon />, component: <Vision /> },
    { label: 'Request', icon: <SendIcon />, component: <RequestForm /> },
    { label: 'Photos', icon: <PhotoCameraIcon />, component: <Photos /> },
    { label: 'Check-in', icon: <CheckCircleIcon />, component: <DailyCheckInNew /> },
    { label: 'CalorieAI', icon: <LocalFireDepartmentIcon />, component: <CalorieAI /> }
  ];



  const handleChange = (event, newValue) => {
    setValue(newValue);
    // Reset overlay states when navigating via bottom navigation
    setShowAddTask(false);
    setShowRequestForm(false);
  };



  return (
    <Box sx={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Main content area */}
      <Box sx={{
        flex: 1,
        width: '100%',
        maxWidth: '600px',
        mx: 'auto',
        px: { xs: 1, sm: 2 },
        pb: 10, // Add padding bottom for navigation bar
        overflow: 'auto'
      }}>
        {showAddTask ? (
           <AddTask />
         ) : showRequestForm ? (
           <RequestForm />
         ) : (
          navConfig.map((nav, index) => (
            <TabPanel key={index} value={value} index={index}>
              {index === 1 ? (
                <TaskSelection 
                  onNavigateToAddTask={() => setShowAddTask(true)}
                  onNavigateToRequest={() => setShowRequestForm(true)}
                />
              ) : (
                nav.component
              )}
            </TabPanel>
          ))
        )}
      </Box>
      
      {/* Bottom Navigation */}
      <Paper 
          sx={{ 
            position: 'fixed', 
            bottom: 8, 
            left: '50%', 
            transform: 'translateX(-50%)',
            width: 'calc(100% - 20px)',
            maxWidth: '500px',
            zIndex: 1000,
            borderRadius: '25px',
            backgroundColor: 'rgba(255, 193, 202, 0.8)', // Light Pink with more transparency
            backdropFilter: 'blur(10px)',
            boxShadow: '0px 4px 20px rgba(199, 0, 166, 0.1)',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            height: '65px',
          }} 
          elevation={0}
        >
        <BottomNavigation
            value={value < 1 ? value : (value > 1 ? value - 1 : -1)}
            onChange={(event, newValue) => {
                handleChange(event, newValue < 1 ? newValue : newValue + 1)
            }}
          sx={{
              backgroundColor: 'transparent',
              width: '100%',
              justifyContent: 'space-evenly',
              '& .MuiBottomNavigationAction-root': {
                color: 'rgba(210, 93, 253, 0.92)',
                transition: 'all 0.5s ease',
                padding: 0,
                minWidth: 'auto',
                '& .MuiBottomNavigationAction-label': {
                  display: 'none',
                },
                '&.Mui-selected': {
                  color: 'rgb(187, 0, 255)',// Pink
                  '& .MuiSvgIcon-root': {
                    transform: 'scale(1.1)',
                  },
                  '& .MuiBottomNavigationAction-label': {
                    display: 'block',
                    opacity: 1,
                    fontSize: '0.7rem',
                  },
                },
              },
            }}
        >
          {navConfig.map((item, index) => {
             if (index === 1) return null; // Skip rendering the middle item, it's the FAB
             return (
               <BottomNavigationAction 
                 key={index} 
                 label={item.label} 
                 icon={item.icon} 
                 sx={{
                   ...(index === 3 && { marginLeft: '25px' }),
                   ...(index === 2 && { marginRight: '25px' }),
                 }}
               />
             );
           }).filter(Boolean)}
        </BottomNavigation>
        <Fab 
          color="secondary" 
          aria-label="task-selection" 
          onClick={() => {
            setValue(1);
            setShowAddTask(false);
            setShowRequestForm(false);
          }} 
          sx={{
            position: 'absolute',
            zIndex: 1,
            top: -20,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgb(255, 144, 207)',// Pink
            '&:hover': {
              backgroundColor: 'rgb(252, 140, 185)', // Darker Pink
            }
          }}
        >
          <span style={{ fontSize: '1.5rem' }}>{'🐷'}</span>
        </Fab>
      </Paper>
    </Box>
  );
}

export default TabView;
